export const ONE_DAY = 86400000;
export const ONE_WEEK = ONE_DAY * 7;
